import { createApiClient } from "./apiClientShared";

/**
 * API client without attaching Authorization on outbound requests.
 * Still shares refresh-on-401 / error formatting with the authenticated client.
 */
export const api_no_token_Service = createApiClient({ withAuth: false });
export default api_no_token_Service;
